module.exports = __webpack_public_path__ + "static/assets/6522710dad0e4d577f33e159dc0207ef.png";